import { apiFetch } from "@/shared/api/http";

export interface TechnicalCriterion {
  chave:string;
  nome:string;
  ordem:number;
  categoria:string;
  peso:number;
  essencial:boolean;
  valorMinimo:number;
  descricao?:string|null;
  perfilEtario:string;
  competenciaChave?:string|null;
  tecnicaChave?:string|null;
  tecnicaNome?:string|null;
}
export interface TechnicalEvaluationItem { chave:string; nome:string; valor:number; }
export interface TechnicalEvaluationPoint {
  avaliacaoId:string;
  data:string;
  turma:string;
  professor:string;
  media:number;
  compartilhada:boolean;
  observacao?:string|null;
  itens:TechnicalEvaluationItem[];
  tipoRegistro:string;
  estadoRapido?:string|null;
  temaAula?:string|null;
  tecnica?:string|null;
}
export interface TechnicalReadiness {
  status:string;
  mediaPonderada:number;
  avaliacoesConsideradas:number;
  pontosAtencao:string[];
  mensagem:string;
}
export interface TechnicalInsight {
  chave:string;
  nome:string;
  categoria:string;
  estado:string;
  evidenciasDetalhadas:number;
  evidenciasRapidas:number;
}
export interface TechnicalEvolutionSummary {
  alunoId:string;
  aluno:string;
  modalidadeId:string;
  modalidade:string;
  perfilEtario:string;
  criterios:TechnicalCriterion[];
  avaliacoes:TechnicalEvaluationPoint[];
  prontidao?:TechnicalReadiness|null;
  pontosFortes:TechnicalInsight[];
  areasEmDesenvolvimento:TechnicalInsight[];
}

export function getStudentTechnicalEvolution(months=6) {
  return apiFetch<TechnicalEvolutionSummary[]>(`/api/app/aluno/evolucao-tecnica?meses=${months}`);
}

export function getResponsibleTechnicalEvolution(studentId:string, months=6) {
  return apiFetch<TechnicalEvolutionSummary[]>(`/api/app/responsavel/alunos/${encodeURIComponent(studentId)}/evolucao-tecnica?meses=${months}`);
}
